import React from "react";
import { motion } from "framer-motion";
import { site } from "@/lib/siteContent";

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-gold text-navy"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-14 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-4 divide-x divide-navy/15">
          {site.stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.08, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`stat-${i}`}
              className={`px-6 md:px-8 ${i === 0 ? "border-l-0" : ""}`}
            >
              <div className="font-display text-5xl lg:text-6xl font-medium leading-none tracking-tight">
                {s.value}
              </div>
              <div className="mt-3 text-[11px] font-bold uppercase tracking-[0.22em] text-navy/80">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
